import React from "react";
import "./LandscapeAlert.scss";

const LandscapeAlert = () => (
  <section className="section section-helpers-landscape">
    <div className="padding">
      <div className="container">
        <div className="landscape-msg">
          לחווית הגלישה הטובה ביותר יש להשאיר את המכשיר במצב Portrait
        </div>
      </div>
    </div>
  </section>
);

export { LandscapeAlert };
